import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
import Dayjs from 'dayjs'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. paging 처리??

/**
 * Report > Alarm Analysis Report
 * Alarm Analysis Report (EQP Alarm 목록)
 */
export default {
  name: 'AlarmAnalysisReport',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toDate () {
      this.fromMaxDate = this.toDate
    }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * Grid Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'alarmDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_ID'), field: 'alarmId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_CODE'), field: 'alarmCode', width: 150 },
        {
          headerName: this.$t('fdc.COMMON.COLUMN.ALARM_SEVERITY'),
          field: 'alarmSeverity',
          width: 100,
          cellStyle: params => {
            if (params.value === 'WARNING') {
              return { color: 'white', backgroundColor: 'rgb(255, 192, 0)', textAlign: 'center' }
            } else if (params.value === 'CRITICAL') {
              return { color: 'white', backgroundColor: 'rgb(184, 9, 9)', textAlign: 'center' }
            } else if (params.value === 'NORMAL') {
              return { backgroundColor: 'rgb(179, 179, 179)', textAlign: 'center' }
            }
            return null
          }
        },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_TEXT'), field: 'alarmText', width: 300 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), field: 'createDt', width: 180, type: 'dateTimeColumn' }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * EQP Alarm List 검색
     */
    searchAlarmAnalysisList () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }

      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.getEqpAlarmList(node.detail.fab, node.detail.eqpId)
    },
    /**
     * EQP Alarm List 조회
     * @param {*} fab Fab
     * @param {*} eqpId EQP ID
     */
    async getEqpAlarmList (fab, eqpId) {
      this.rowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
      }

      let data = await API.Monitor.getEqpsAlarms(payload)
      this.rowData = _.clone(data)
    },
    /**
     * Export Excel
     * 조회된 data를 Excel 파일로 다운로드 합니다.
     */
    exportEqpAlarmGrid () {
      // this.$refs.eqpAlarmGrid.exportExcel('AlarmAnalysisReport')
      this.$refs.eqpAlarmGrid.gridApi.exportDataAsCsv({
        fileName: 'AlarmAnalysisReport.csv'
      })
    }
  },
  data () {
    const dateString = new Date().toDateString()
    let fromDt = new Date(Dayjs(dateString).add(-1, 'day').format('YYYY.MM.DD'))
    let toDt = new Date()
    return {
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), binding: 'alarmDt', width: 180, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM_ID'), binding: 'alarmId', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM_CODE'), binding: 'alarmCode', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM_TEXT'), binding: 'alarmText', width: 300, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), binding: 'createDt', width: 180, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' }
      // ], // EQP Alarm List grid column 배열
      columns: [], // EQP Alarm List grid column 배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // EQP Alarm List grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색된 EQP Tree node
      fromDate: fromDt, // From Date value
      toDate: toDt, // To Date value
      fromMaxDate: toDt, // From Date Max value
      fromMinDate: null, // From Date Min value
      toMaxDate: toDt, // To Date Max value
      toMinDate: fromDt // To Date Min value
    }
  }
}
